import { UserRound } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const UserRoundIcon = createLucideIcon(UserRound);
